import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { HYDRATE } from 'next-redux-wrapper'
import { searchInitialState } from '@/store/states/SearchInitialState'
import {
  resetAllFilters,
  setCurrentLayoutType,
  setFiltersParams,
  setIsInfiniteScroll,
  setIsLoadingItems,
  setItems,
  setPagesMap,
  setSelectedItem,
  updateFiltersParams,
  updatePaginationParams,
} from '@/store/reducers/SearchReducers'
import {
  fetchItemsPending,
  fetchItemsRejected,
  fetchItemsSuccess,
} from '@/store/actions/searchActions'
import { fetchAdsThunk } from '@/store/thunks/searchThunks'
import { getInitialClassicFiltersParams } from '@/common/utils/transformFilters'

export const fetchFiltersClassicConfig = createAsyncThunk(
  'adsClassic/fetchFiltersClassicConfig',
  async ({ token, filtersConfigRequest }, { rejectWithValue }) => {
    try {
      const config = await filtersConfigRequest(token)
      return config
    } catch (e) {
      return rejectWithValue(e)
    }
  }
)

export const fetchAdClassic = createAsyncThunk(
  'adsClassic/fetchAd',
  async ({ params, request }, { rejectWithValue }) => {
    try {
      const data = await request(params)
      return data
    } catch (e) {
      return rejectWithValue(e)
    }
  }
)

export const adsClassicSlice = createSlice({
  name: 'adsClassic',
  initialState: {
    ...searchInitialState,
    isAdsDetailsLoading: false,
    isVisibleBlackListModal: false,
    currentSlideData: null,
    needFetchAds: true,
    favoriteGroupsMap: {
      pagination: null,
      groups: [],
    },
    activeVideo: null,
    prevActiveVideo: null,
    isCoverage: false,
    isActiveBlackList: false,
  },
  reducers: {
    setIsActiveBlackListClassic(state, { payload }) {
      state.isActiveBlackList = payload
    },
    setLayoutTypeClassic: setCurrentLayoutType,
    setFavoriteGroupsMap(state, { payload }) {
      state.favoriteGroupsMap = payload
    },
    setIsVisibleBlackListClassicModal(state, { payload }) {
      state.isVisibleBlackListModal = payload
    },
    setIsLoadingClassic: setIsLoadingItems,
    setIsActiveInfiniteScrollClassic: setIsInfiniteScroll,
    setCurrentSlideDataAds(state, { payload }) {
      state.currentSlideData = payload
    },
    updatePaginationParamsClassic: updatePaginationParams,
    updateFiltersParamsClassic: updateFiltersParams,
    setAdsClassic: setItems,
    setPagesMapClassic: setPagesMap,
    setSelectedAdClassic: setSelectedItem,
    setIsCoverageAdsClassic(state, { payload }) {
      state.isCoverage = payload
    },
    setActiveVideoAdsClassic(state, { payload }) {
      state.prevActiveVideo = state.activeVideo
      state.activeVideo = payload
    },
    setIsLoadingByPaginationClassic(state, { payload }) {
      state.isLoadingByPagination = payload
    },
    setFiltersParamsClassic: setFiltersParams,
    resetAllFiltersClassic: resetAllFilters,
  },
  extraReducers: (builder) => {
    builder
      .addCase(HYDRATE, (state, { payload }) => {
        const { adsClassic } = payload

        if (adsClassic.filtersConfig) {
          state.filtersConfig = adsClassic.filtersConfig
        }

        if (!state.filtersParams) {
          state.filtersParams = adsClassic.filtersParams
        }

        state.selectedItem = adsClassic.selectedItem
      })
      .addCase(fetchAdsClassic.pending, fetchItemsPending)
      .addCase(fetchAdsClassic.fulfilled, fetchItemsSuccess)
      .addCase(fetchAdsClassic.rejected, fetchItemsRejected)
      .addCase(fetchAdClassic.pending, (state) => {
        state.isCreativeDetailsLoading = true
      })
      .addCase(fetchAdClassic.fulfilled, (state, { payload }) => {
        state.isCreativeDetailsLoading = false
        state.selectedItem = payload
      })
      .addCase(fetchAdClassic.rejected, (state) => {
        state.isCreativeDetailsLoading = false
      })
      .addCase(fetchFiltersClassicConfig.pending, (state) => {
        state.isFiltersLoading = true
      })
      .addCase(fetchFiltersClassicConfig.fulfilled, (state, { payload }) => {
        state.filtersConfig = payload
        state.isFiltersLoading = false

        if (!state.filtersParams) {
          state.filtersParams = getInitialClassicFiltersParams(payload)
        }
      })
      .addCase(fetchFiltersClassicConfig.rejected, (state) => {
        state.isFiltersLoading = false
      })
  },
})

export const adsClassicActions = adsClassicSlice.actions

export const fetchAdsClassic = fetchAdsThunk(
  'adsClassic',
  adsClassicActions['setAdsClassic']
)

export default adsClassicSlice.reducer
